<template>
	<div id="redbag" class="redbag">
		<div class="m-header" :style="'background-image:url('+imgPath+'redbag/hongbaohead_03.png)'">
		     <p class="u-title">发红包</p>
		     <img @click="closeAction" :src="imgPath+'redbag/redclose_03.png'" class="close">
		</div>
		<div class="m-bottom">
			<ul class="clearfix">
				<li class="m-li" @click="tabSelect(0)"><a class="u-tab" :class="{action:master}">打赏红包</a></li>
				<li class="m-li" @click="tabSelect(1)"><a class="u-tab" :class="{action:!master}">拼手气红包</a></li>
			</ul>
			   <div class="m-tab1" v-show="master">
			   	<div class="u-input">
			   	   	<span class="m-totalmoney">总金额</span>
			   	   	<input type="number" @blur="blurAction" v-model="sumMoney" class="m-textfiled" placeholder="0"/>
			   	   	<span class="u-unit">元</span>
			   	</div>
			   	<p class="u-detail" v-if="ds_id != 194">打赏红包为向主办方打赏</p>
			   	<p class="u-detail" v-else>向主演打赏</p>
			   	    <div class="u-input">
			   	   		<span class="m-totalmoney">留言</span>
			   	   		<input type="text" @blur="blurAction" v-model="message" class="text" placeholder="恭喜发财，大吉大利"/>
			   		</div>
			   </div>
			   
			   <div class="m-tab2" v-show="!master">
			   	   <div class="u-input">
			   	   	<span class="m-totalmoney">总金额</span>
			   	   	<input type="number" @blur="blurAction" v-model="redsumMoney" class="m-textfiled" placeholder="0"/>
			   	   	<span class="u-unit">元</span>
			   	   </div>
			   	   <p class="u-detail">拼手气红包为向观众打赏</p>
			   	   <div class="u-input">
			   	   	<span class="m-totalmoney">红包个数</span>
			   	   	<input type="number" @blur="blurAction" v-model="rednum" class="m-textfiled" placeholder="填写个数" max="50" min="1"/>
			   	   	<span class="u-unit">个</span>
			   	   </div>
			   	   <div class="u-input">
			   	   	  <span class="m-totalmoney">留言</span>
			   	   	<input type="text" @blur="blurAction" v-model="redMessage" class="text" placeholder="恭喜发财，大吉大利"/>
			   	   </div>
			   </div>
			   	
			   	<button class="u-redbtn" @click="sendRedAction()">发红包</button>
		</div>
	</div>
</template>

<script>
	import {Toast,Dialog} from 'vant';
    import vxxData from '../../kits/data.js';
    import tool from '../../kits/Tools.js';
	
	export default {
		props:['fans_id'],
		data() {
			return {
				sendType:0,
				sumMoney:'',
				message:'',
				redsumMoney:'',
				rednum:'',
				redMessage:'',
				master:true,
				ds_id:'',
				imgPath:''
			}
		},
		mounted(){
			this.ds_id = tool.getQueryDsId();
			this.imgPath = tool.imgPath();
		},
		methods:{
			tabSelect(tabsel){
				if(tabsel == 0){
					 this.sendType = 0;
					 this.sumMoney = "";
					 this.message = '';
					 this.master = true;
				}else{
					 this.sendType = 1;
					 this.redsumMoney = "";
					 this.redMessage = "";
					 this.rednum     = "";
					 this.master = false;
				}
			},
			closeAction (){
			    this.redsumMoney = "";
				this.redMessage = "";
				this.rednum     = "";
				this.sumMoney = "";
			    this.message = '';
			  	this.$emit('close');
			},
			blurAction(){
			  window.scrollTo(0,0);	
			},
			sendRedAction (){
			  	var that = this;
			  	var url;
			  	var option;
			    if(this.sendType == 1){
			    	if(Number(this.redsumMoney) < 1){
			    	   	Toast('红包金额不能小于1元');
			    	   	return;
			    	}
					if (Number(this.rednum) < 1) {
						Toast('请输入红包个数');
						return;
					}
					url = tool.baseUrl() + "/redPacket/index/randomRedpacket";
			       	option = 'fans_id='+this.fans_id+'&ds_id='+this.ds_id+'&msg='+this.redMessage+'&nums='+this.rednum+'&money='+this.redsumMoney;
			    }else{//打赏红包
			    	if (Number(this.sumMoney) < 1) {
			    	    Toast('红包金额不能小于1元');
			    	    return;
				    }
			    	url = tool.baseUrl() + "/redPacket/index/rewardRedpacket";
			    	option = 'fans_id='+this.fans_id+'&ds_id='+this.ds_id+'&msg='+this.message+'&money='+this.sumMoney;
			    }
			    console.log(option)
		       	this.axios.post(url,option).then(function(res){
		       		that.payFunc(res);
		       	}).catch(function(res){
		       		Toast(res.message);
		       		that.closeAction();
		       	})
			  },
			payFunc(res){
			  	var data = res.data;
	       		if(data.code == 200){
					if(typeof WeixinJSBridge == "undefined"){
					   if( document.addEventListener ){
					       document.addEventListener('WeixinJSBridgeReady', weixinPay, false);
					   }else if (document.attachEvent){
					       document.attachEvent('WeixinJSBridgeReady', weixinPay);
					       document.attachEvent('onWeixinJSBridgeReady', weixinPay);
					   }
					}else{
						this.weixinPay(data.data);
					}
				}else{
					if(data.message){
						Toast(data.message);
					}
				}
			},
			weixinPay (p){
			  	var that = this;
			  	var params =  'appId:' + p.appId +'timeStamp:' +  p.timeStamp +'nonceStr:' +  p.nonceStr + 'package:' + p.package +'sing:' +p.paySign;
			  	WeixinJSBridge.invoke(
                   'getBrandWCPayRequest', {
	                    "appId":p.appId,     //公众号名称，由商户传入     
	                    "timeStamp":String(p.timeStamp),//时间戳，自1970年以来的秒数     
	                    "nonceStr":p.nonceStr, //随机串     
	                    "package":p.package,
	                    "signType":"MD5",         //微信签名方式：
	                    "paySign":p.paySign //微信签名 
			       },
			       function(res){
			       	    // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回    ok，但并不保证它绝对可靠。
			           if(res.errMsg == "get_brand_wcpay_request:ok" || res.err_msg == "get_brand_wcpay_request:ok") {
			           	    Toast('发送红包成功！');
			                that.closeAction();
			           }else{
			           	   Toast('支付失败！');
			           }
			    	}
				)
			}
		}
	}
</script>

<style scoped>
#redbag{
	margin: -10px;
	background:rgba(233,37,30,1);
	padding-bottom: 20px;
	line-height: 20px;
	text-align: left;
}
.m-header{
	background-repeat: no-repeat;
	background-size: 100% 100%;
	height: 55px;
	line-height: 40px;
}
.u-title{
	text-align: center;
	font-size: 17px;
	color: #ebcb8a;
}
.m-li{
	float: left;
	width: 50%;
	text-align: center;
	font-size: 15px;
	color: #fff;
}
.redbag .close{
	width: 20px;
	height: auto;
	top: 10px;
	right: 12px;
}
.u-tab{
	display: inline-block;
	padding-bottom: 6px;
	color: #d6b87d;
}
.action{
    color: #ffe0a1;
	border-bottom: 4px solid #ffe0a1;
}
.m-bottom{
	width: 90%;margin: 0 auto;
}
.u-detail{
	padding: 0px 0px 15px 20px;
	font-size: 13px;
	font-weight: normal;
	font-stretch: normal;
	color: #ffffff;
}
.u-input{
	 border-radius: 4px;
	 background-color: white;
	 height: 40px;
	 line-height: 40px;
	 margin-bottom: 15px;
	 display: flex;
	color: #333333;
}
.m-totalmoney{
	margin:0 10px;
	width:60px;
	white-space:nowrap;
}
.m-textfiled{
	flex: 1;
	text-align: right;
	border: none;
	color: #999999;
	padding: 0;
	height: 40px;
	line-height: 40px;
}
.u-unit{
	display: inline-block;
	padding:0 10px;
}
.text{
	padding:0 10px 0 0;
	border: none;
	flex:1;
	text-align: right;
	height: 40px;
	line-height: 40px;
}
.u-redbtn{
	display: block;
	width: 100%;
	background: #ebcb8a;
	border-radius: 20px;
	line-height: 40px;
	color: #e9251e;
	font-size: 15px;
	border: none;
}
</style>


// WEBPACK FOOTER //
// rewardRedBag.vue?482a44b6